import React from 'react';
import { Button } from '../../elements';
export const ModalHeader = ({ children, onBackClick, onCloseClick }) => (React.createElement("div", { className: "modal__header" },
    onBackClick && (React.createElement(Button, { secondaryBlue: true, iconButton: true, icon: "arrowLeft", className: "modal__back", onClick: onBackClick })),
    children,
    onCloseClick && (React.createElement(Button, { secondary: true, iconButton: true, icon: "close", className: "modal__close", onClick: onCloseClick }))));
//# sourceMappingURL=ModalHeader.js.map